/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedShippingInfo_user = {
    readonly serviceId: string | null;
    readonly addressBook: {
        readonly proAddress: {
            readonly displayCountry: string | null;
            readonly zipCode: string | null;
        } | null;
        readonly personalAddress: {
            readonly displayCountry: string | null;
            readonly zipCode: string | null;
        } | null;
        readonly addressList: ReadonlyArray<{
            readonly displayCountry: string | null;
            readonly zipCode: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedPromoCode_user">;
    readonly " $refType": "PdpSharedShippingInfo_user";
};
export type PdpSharedShippingInfo_user$data = PdpSharedShippingInfo_user;
export type PdpSharedShippingInfo_user$key = {
    readonly " $data"?: PdpSharedShippingInfo_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_user">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayCountry",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "zipCode",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfo_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "proAddress",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "personalAddress",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();
(node as any).hash = '8d64b4e2465c4c570ec2a86501d5a11a';
export default node;
